export enum ProgressStatusAppearance {
  ICON = 'icon',
  STATUS_CARD_IMAGE = 'status-up-image',
  LION_CARD_MOV = 'lion-card-animation-mov',
  LION_CARD_WEBM = 'lion-card-animation-webm',
}
